'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UIHelpIcon = require('../icon/UIHelpIcon');

var _UIHelpIcon2 = _interopRequireDefault(_UIHelpIcon);

var _UIFormLabel = require('./UIFormLabel');

var _UIFormLabel2 = _interopRequireDefault(_UIFormLabel);

var _UICheckbox = require('../input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _PlacementConstants = require('../tooltip/PlacementConstants');

var _elements = require('../elements');

var _Functions = require('../core/Functions');

var _validateUIFormControlValidationMessage = require('./utils/validateUIFormControlValidationMessage');

var _validateUIFormControlValidationMessage2 = _interopRequireDefault(_validateUIFormControlValidationMessage);

var _underscore = require('../utils/underscore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var sizeClasses = {
  small: 'private-form__control--small',
  medium: ''
};

var getClassName = function getClassName(className, error, label, _size) {
  return (0, _reactUtils.classNames)('private-form__set', className, sizeClasses[_size], {
    'private-form__set--error': !!error,
    'private-form__set--no-label': !label
  });
};

var getClosestDescendantId = function getClosestDescendantId(child) {
  var element = child;
  var id = element.props.id;
  while (id == null) {
    try {
      element = _react.Children.only(element.props.children);
    } catch (e) {
      break;
    }
    id = element.props.id;
  }
  return id;
};

var getDerivedId = function getDerivedId(inputProps, id) {
  var IDs = Object.keys(inputProps).filter(function (prop) {
    return inputProps[prop];
  }).map(function (prop) {
    if (!inputProps[prop]) return '';
    return id + '-' + prop;
  });
  if (IDs.length > 0) return IDs.join(' ');
  return undefined;
};

var getHtmlFor = function getHtmlFor(propValue, children) {
  var firstChild = _react.Children.only(children);

  if (propValue) {
    return propValue;
  }

  if (firstChild) {
    return getClosestDescendantId(firstChild) || name;
  }

  return null;
};

var renderInput = function renderInput(ariaLabel, ariaLabelledBy, children, description, error, help, required, validationMessage, disabledFieldset, inputRefCallback, fallbackId) {
  var child = _react.Children.only(children);
  var origRequired = child.props.required;

  // if the child input doesn't declare `required`, pass it down

  var newRequired = required === true ? true : origRequired;
  var newError = error === true ? 'true' : undefined;

  var cloneProps = {
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    ref: (0, _Functions.stackRefs)('UIFormControl', child.ref, inputRefCallback),
    required: newRequired,
    'aria-invalid': newError,
    'aria-required': newRequired
  };

  // only add id prop if it doesn't have it already
  var descendantId = getClosestDescendantId(child);
  if (!descendantId) {
    cloneProps.id = fallbackId;
  }

  // only add error prop if there is an error, to avoid potential "Unknown prop" warnings
  if (error) {
    cloneProps.error = !!error;
  }

  // disable the input if we're within a disabled fieldset (#3356)
  if (disabledFieldset) {
    cloneProps.disabled = true;
  }

  // aggregate IDs to pass into aria-describedby
  var newDescribedBy = getDerivedId({ validationMessage: validationMessage, help: help, description: description }, cloneProps.id);

  // derive ID and spread back into cloneProps
  var describedCloneProps = {
    'aria-describedby': newDescribedBy
  };

  var mergedCloneProps = _extends({}, cloneProps, describedCloneProps);

  return (0, _react.cloneElement)(child, mergedCloneProps);
};

var renderLabel = function renderLabel(ariaLabel, ariaLabelledBy, children, label, labelClassName, error, htmlFor, required, tooltip, tooltipPlacement, renderedInput) {
  if (!label && !ariaLabel && !ariaLabelledBy && _react.Children.only(children).type !== _UICheckbox2.default) {
    _devLogger2.default.warn({
      message: "UIFormControl: For better accessibility, if you're going to omit `label`, please include an `aria-label` or `aria-labelledby` property.",
      key: 'UIFormControl: add aria-label'
    });
  }

  if (!label) return null;

  var renderedLabel = _react2.default.createElement(
    _UIFormLabel2.default,
    {
      className: (0, _reactUtils.classNames)(labelClassName, {
        'private-form__label--with-tooltip': !!tooltip
      }),
      error: !!error,
      htmlFor: getHtmlFor(htmlFor, renderedInput),
      required: required
    },
    label
  );

  return tooltip ? _react2.default.createElement(
    _UIHelpIcon2.default,
    {
      className: 'private-form__help-tooltip',
      title: tooltip,
      tooltipProps: { placement: tooltipPlacement }
    },
    renderedLabel
  ) : renderedLabel;
};

var renderHelp = function renderHelp(help, helpClassName, renderedInputId) {
  if (!help) return null;

  return _react2.default.createElement(
    'span',
    {
      className: (0, _reactUtils.classNames)('private-form__inlinehelp', helpClassName),
      id: getDerivedId({ help: help }, renderedInputId),
      tabIndex: -1
    },
    help
  );
};

var renderValidation = function renderValidation(error, validationMessage, inputId) {
  var validationClass = 'private-form__validation';

  if (validationMessage) {
    (0, _validateUIFormControlValidationMessage2.default)({ error: error, validationMessage: validationMessage });

    return _react2.default.createElement(
      _elements.Small,
      {
        className: validationClass,
        id: getDerivedId({ validationMessage: validationMessage }, inputId),
        tabIndex: -1,
        use: error ? 'error' : 'success'
      },
      validationMessage
    );
  }

  return null;
};

var renderCounter = function renderCounter(characterCount) {
  return characterCount == null ? null : _react2.default.createElement(
    _elements.Small,
    { className: 'private-form__counter' },
    characterCount
  );
};

var renderDescription = function renderDescription(description, inputId) {
  return !description ? null : _react2.default.createElement(
    _elements.Small,
    {
      className: 'private-form__description',
      id: getDerivedId({ description: description }, inputId),
      tabIndex: -1,
      use: 'help'
    },
    description
  );
};

/**
 * Group a form field, label, notes, and errors/alerts together
 **/
exports.default = _react2.default.createClass({
  displayName: 'UIFormControl',

  propTypes: {
    /**
     * Instructional text to display with the field label
     **/
    'aria-label': _react.PropTypes.string,

    /** List of IDs that label this input */
    'aria-labelledby': _react.PropTypes.string,

    /**
     * Display character count metadata beneath the input
     */
    characterCount: _react.PropTypes.node,

    /**
     * Pass the form input as a child. Label will be linked by provided ID, or
     * a random unique ID will be assigned to the input for linking.
     **/
    children: _react.PropTypes.node.isRequired,

    className: _react.PropTypes.string,

    /**
     * Detailed description of component. Similar to `help` but more in-depth
     **/
    description: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.bool]),

    /**
     * `true` indicates this field is in an error state
     **/
    error: _react.PropTypes.bool,

    /**
     * Message to be displayed at the bottom of the input
     *
     * By default the text is green
     * If `error` is set to `true` then the text is red
     **/
    validationMessage: _react.PropTypes.node,

    /**
     * Instructional text to display with the field label
     **/
    help: _react.PropTypes.node,

    /**
     * Class name for the <span> wrapper around the `text` prop
     **/
    helpClassName: _react.PropTypes.string,

    /**
     * `id` attribute of the input field you want label to be bound to
     *
     * By default, the `<label />` will be linked to the embedded `<input />`
     * using the `for` attribute. Use this if you need to override that behavior
     **/
    htmlFor: _react.PropTypes.string,

    /**
     * Renders a clickable <UIFormLabel /> alongside input with this text as content
     **/
    label: _react.PropTypes.node,

    /**
     * Class name for the rendered <UIFormLabel /> component
     **/
    labelClassName: _react.PropTypes.string,

    /**
     * `true` indicates the field is required and will be styled accordingly
     **/
    required: _react.PropTypes.bool.isRequired,

    /**
     * Instructional text to display with the the '?' icon and tooltip
     **/
    tooltip: _react.PropTypes.node,

    /**
     * Placement of the tooltip
     **/
    tooltipPlacement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,

    /**
     * @private
     * Enables smaller sized inputs. This is not supported for all input types.
     **/
    _size: _react.PropTypes.oneOf(Object.keys(sizeClasses))
  },

  contextTypes: {
    disabledFieldset: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      required: false,
      tooltipPlacement: 'top',
      _size: 'medium'
    };
  },
  componentWillMount: function componentWillMount() {
    this._fallbackId = 'UIFormControl-' + (0, _underscore.uniqueId)();
  },
  focus: function focus() {
    if (this._input && typeof this._input.focus === 'function') {
      this._input.focus();
    }
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._input = ref;
  },
  render: function render() {
    var _props = this.props,
        ariaLabel = _props['aria-label'],
        ariaLabelledBy = _props['aria-labelledby'],
        characterCount = _props.characterCount,
        children = _props.children,
        className = _props.className,
        description = _props.description,
        error = _props.error,
        validationMessage = _props.validationMessage,
        help = _props.help,
        helpClassName = _props.helpClassName,
        htmlFor = _props.htmlFor,
        label = _props.label,
        labelClassName = _props.labelClassName,
        required = _props.required,
        tooltip = _props.tooltip,
        tooltipPlacement = _props.tooltipPlacement,
        _size = _props._size,
        rest = _objectWithoutProperties(_props, ['aria-label', 'aria-labelledby', 'characterCount', 'children', 'className', 'description', 'error', 'validationMessage', 'help', 'helpClassName', 'htmlFor', 'label', 'labelClassName', 'required', 'tooltip', 'tooltipPlacement', '_size']);

    var classes = getClassName(className, error, label, _size);
    var renderedInput = renderInput(ariaLabel, ariaLabelledBy, children, description, error, help, required, validationMessage, this.context.disabledFieldset, this.inputRefCallback, this._fallbackId);

    var inputId = renderedInput && renderedInput.props && renderedInput.props.id;

    return _react2.default.createElement(
      'div',
      _extends({ className: classes }, rest),
      _react2.default.createElement(
        'div',
        { className: 'private-form__control-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'private-form__label-wrapper' },
          renderLabel(ariaLabel, ariaLabelledBy, children, label, labelClassName, error, htmlFor, required, tooltip, tooltipPlacement, renderedInput),
          renderHelp(help, helpClassName, inputId)
        ),
        _react2.default.createElement(
          'div',
          { className: 'private-form__input-wrapper' },
          renderedInput
        ),
        _react2.default.createElement(
          'div',
          { className: 'private-form__meta' },
          _react2.default.createElement(
            'div',
            { className: 'private-form__messages' },
            renderValidation(error, validationMessage, inputId)
          ),
          renderCounter(characterCount)
        ),
        renderDescription(description, inputId)
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/form/UIFormControl.js
// module id = 346
// module chunks = 0